<template>
  <div class="kk-tools">
    <blue-zone-header title="Tools" :is-loading="false"></blue-zone-header>

    <!-- Body -->
    <div class="kk-tools__tree">Inside the tools</div>
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import blueZoneHeader from "../BlueZoneHeader.vue";

export default {
  components: {
    blueZoneHeader,
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  beforeUnmount() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.kk-tools {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  &__tree {
    padding: 0.4rem;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
